import { format, parseISO } from 'date-fns';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

// Extend dayjs with UTC support
dayjs.extend(utc);

export function currentUTCTime(): number {
  return dayjs.utc().valueOf();
}

export function currentUnixTime(): number {
  return dayjs.utc().unix();
}

export function currentUTCExpiryTime(): number {
  const utcNow = dayjs.utc();
  let expiryTime = utcNow.hour(8).minute(0).second(0).millisecond(0);
  if (utcNow.hour() >= 8) {
    expiryTime = expiryTime.add(1, 'day');
  }

  return expiryTime.valueOf();
}

export function formatDate(timestamps: number, formatter = 'MM-DD HH:mm:ss'): string {
  return dayjs(timestamps).format(formatter);
}

export function showProperDateString({
  expiry,
  format,
}: {
  expiry: number;
  format: string;
}): string {
  return formatDate(expiry * 1000, format);
}

// 时间间隔枚举（简化版）
export enum TimeInterval {
  MINUTE = '1m',
  FIVE_MINUTE = '5m',
  FIFTEEN_MINUTE = '15m',
  THIRTY_MINUTE = '30m',
  HOUR = '1h',
  DAY = '1d',
  WEEK = '1w',
}

export function getTimeDuration(interval: TimeInterval): number {
  switch (interval) {
    case TimeInterval.DAY:
      return 24 * 60 * 60;
    case TimeInterval.WEEK:
      return 7 * 24 * 60 * 60;
    case TimeInterval.HOUR:
      return 60 * 60;
    case TimeInterval.THIRTY_MINUTE:
      return 30 * 60;
    case TimeInterval.FIFTEEN_MINUTE:
      return 15 * 60;
    case TimeInterval.FIVE_MINUTE:
      return 5 * 60;
    case TimeInterval.MINUTE:
      return 60;
    default:
      return 0;
  }
}

/**
 * Format date for tooltip display (e.g., "Jan 28, 2026")
 */
export function formatTooltipDate(dateStr: string): string {
  try {
    const date = parseISO(dateStr);
    return format(date, 'MMM d, yyyy');
  } catch {
    return dateStr;
  }
}
